const tools = {
    formatMagazineData (data, str = '-l') {
        function findUrl (arr, searchStr) {
            return arr.find((e) => {
                console.log()
                return e.includes(searchStr)
            })
        }
        data.forEach((e) => {
            e.__cover = findUrl(e.CoverImages, str)
            e.__midInfo = `${ e.Year }年${ (`0${ e.Issue }`).substr(-2) }期`
            e.__bottomInfo = e.Note ? e.Note : e.Intro
        })
        return data
    },
    formatBookData (data) {
        data.forEach((e) => {
            e.__cover = e.CoverImage
            e.__midInfo = `作者: ${ e.Author }`
            e.__bottomInfo = e.PublishName ? `出版社: ${ e.PublishName }` : '出版社: 无'
        })
        return data
    },
    formatNewspaperData(data)
    {
        data.forEach((e) => {
            e.__cover = e.CoverImgURL
            e.__midInfo = e.PubDate
            e.__bottomInfo = e.Intro
        })
        return data
    },
    formatArticlelibraryData(data)
    {
        return data
    },
    formatTime (t, bool) {
        t = parseInt(t)
        const arr = [parseInt(t / 3600) || 'a', parseInt(t / 60) % 60, t % 60]
            .map((v) => {
                return `0${ v }`.substr(-2)
            })
        if (bool) {
            const hour = arr[0] === '0a' ? '' : `${ arr[0] } 时 `
            const min = arr[1] === '0a' ? '' : `${ arr[1] } 分 `
            const sec = arr[2] === '0a' ? '' : `${ arr[2] } 秒`
            return hour + min + sec
        }
        return arr.join(':').replace('0a:', '')
    },
    formatActors (arr) {
        const nameArr = arr.map((e) => {
            return e.Name
        })
        return nameArr.join(' ')
    },
    formatAudioData (data, showDuration) {
        data.forEach((e) => {
            e.__cover = e.ImageUrl
            //e.__bottomInfo = e.Actors ? `演播者: ${ this.formatActors(e.Actors) }` : '演播者: 佚名播者'
            e.__bottomInfo = e.Intro ? e.Intro : ''
            if (showDuration) {
                e.__bottomInfo = e.Duration ? `总时长: ${ this.formatTime(e.Duration) }` : '总时长: 暂无'
            }
        })
        return data
    },
   formatVideoData (data, showDuration) {
        data.forEach((e) => {
            e.__cover = e.ImageUrl
            //e.__bottomInfo = e.Actors ? `演播者: ${ this.formatActors(e.Actors) }` : '演播者: 佚名播者'
            e.__bottomInfo = e.Intro ? e.Intro : ''
            if (showDuration) {
                e.__bottomInfo = ''
            }
        })
        return data
    },
    forMatFirstWord (str) {
        return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => { return L.toUpperCase() })
    },
    goDetailRoute (resourceType, item, cate) {
        let name
        const params = {
            resourceType,
            cateCode: 'cateCode',
            cateName: 'cateName'
        }
        if (cate) {
            params.cateCode = cate.CategoryCode
            params.cateName = cate.CategoryName
        }
        switch (resourceType) {
        case 'audio':
            name = 'detailAudio'
            params.id = item.ID
            break
        case 'video':
            name = 'detailVideo'
            params.id = item.ID
            break
        case 'magazine':
            name = 'detailPaper'
            params.id = item.ID
            params.year = item.Year
            params.issue = item.Issue
            break
        case 'book':
            name = 'detailPaper'
            params.id = item.ID
            params.year = 'book'
            params.issue = 'book'
            break
        case 'newspaper':
            name = 'detailPaper'
            params.id = item.ID
            params.year = item.PubDate
            params.issue = item.CodeName
            break
        default:
            break
        }
        if (resourceType === 'audio') {
            name = 'detailAudio'
        } else {
            if(resourceType === 'video')
            {
                name = 'detailVideo'
            }else
            {
                name = 'detailPaper'
            }
        }
        this.$router.push({
            name,
            params
        })
    },
    isSameParams (params, lastParams) {
        let bool = true

        for (const attr in params) {
            if (Object.hasOwnProperty.call(params, attr)) {
                const val = `${ params[attr] }`
                const oldVal = `${ lastParams[attr] }`
                if (val !== oldVal) {
                    bool = false
                    break
                }
            }
        }

        return bool
    },
    setLocalStorage (key, value) {
        console.log(key)
        if (typeof value !== 'string') {
            value = JSON.stringify(value)
            console.log(value)
        }
        localStorage.setItem(key, value)
    },
    getLocalStorage (key) {
        return localStorage.getItem(key)
    },
    checkBindMobile(code)
    {
        if(code === 5){
            let serviceid = sessionStorage.getItem("serviceid");
            let virtualPath = sessionStorage.getItem("virtualPath");
            let origin = window.location.origin;

            let verifyurl = `/api/authentification/verifyPhoneNumberSignin?`;
            if(serviceid){
                verifyurl+=`serviceId=${serviceid}&`;
            }
            verifyurl+=`backurl=${encodeURIComponent(`${origin}${virtualPath}default?redirect=${encodeURIComponent(window.location.href)}`)}`;
      
            let desturl = `${origin}/verifier/phoneNumber.html?verifierUrl=${encodeURIComponent(verifyurl)}`;
            window.location.href=desturl;
        }
    },
    initAuthorCanvas(str,id="myCanvas") {
        var c=document.getElementById(id);
        var ctx=c.getContext("2d");

        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, 500,20);

        ctx.fillStyle="#abadb1"; 
        ctx.font = "16px solid"; 
        ctx.fillText(`作者：${str}`,0,14);
    },
    nocover(e)
    {
        let img = e.srcElement;
        img.src = img.attributes.src2.value;
        img.onerror = null;
    },
        removeHtml(str)
    {
        if(!str)return;
        return str.replace(/<[^>]+>/ig,'');
    },
}

export default tools
